import axios from 'axios';
import CONFIG from '../config/constants';

// Login API
export const login = async (email, password) => {
  try {
    const response = await axios.post(`${CONFIG.API_URL}/auth/signin/`, { email, password });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Login failed.' };
  }
};

// Login API
export const authWithGoogle = async (id_token) => {
  try {
    const response = await axios.post(`${CONFIG.API_URL}/auth/socials/google/`, { id_token });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Login failed.' };
  }
};

// Signup API
export const signup = async (email, password, confirmPassword) => {
  try {
    const response = await axios.post(`${CONFIG.API_URL}/auth/signup/`, { email, password, confirm_password: confirmPassword });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Signup failed.' };
  }
};

// Verify Email API
export const verifyEmail = async (token) => {
  try {
    const response = await axios.get(`${CONFIG.API_URL}/auth/verify-email/?token=${token}`);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Verification failed.' };
  }
};

// Forgot Password API
export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(`${CONFIG.API_URL}/auth/forgot-password/`, { email });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Request failed.' };
  }
};

// Reset Password API
export const resetPassword = async (newPassword, confirmPassword, resetToken) => {
  try {
    const response = await axios.post(
      `${CONFIG.API_URL}/auth/reset-password/?token=${resetToken}`,
      { new_password: newPassword, confirm_password: confirmPassword }
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Reset password failed.'};
  }
};

// Logout API
export const logout = async (token) => {
  try {
    const response = await axios.post(
      `${CONFIG.API_URL}/auth/logout/`,
      {},
      { headers: { Authorization: `Token ${token}` } }
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Logout failed.' };
  }
};

// Change Password API
export const changePassword = async (oldPassword, newPassword, confirmPassword, token) => {
  const response = await axios.post(
    `${CONFIG.API_URL}/auth/change-password/`,
    { current_password: oldPassword, new_password: newPassword, confirm_password: confirmPassword },
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

// Get user profile
export const getUserProfile = async (token) => {
  try {
    const response = await axios.get(`${CONFIG.API_URL}/auth/profile/`, { headers: { Authorization: `Token ${token}` } });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Request failed.' };
  }
};

// Upload Images for Video Generation
export const uploadImages = async (model_input, upper_input, lower_input, dress_input, token) => {
  try {
    const formData = new FormData();
    formData.append('model_input', model_input);
    formData.append('upper_input', upper_input);
    formData.append('lower_input', lower_input);
    formData.append('dress_input', dress_input);
    const response = await axios.post(
      `${CONFIG.API_URL}/tryon/image/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data', Authorization: `Token ${token}` } }
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Request failed.' };
  }
};

// Get Tryon Image Status
export const getTryonImageStatus = async (task_id, token) => {
  try {
    const response = await axios.get(`${CONFIG.API_URL}/tryon/image/${task_id}`, { headers: { Authorization: `Token ${token}` } });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Request failed.' };
  }
};

// Create video from Tryon task id
export const createVideo = async (task_id, token) => {
  try {
    const response = await axios.post(
      `${CONFIG.API_URL}/tryon/video/`,
      { tryon_id: task_id },
      { headers: { Authorization: `Token ${token}` }
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Request failed.' };
  }
};

// Get Tryon Video Status
export const getTryonVideoStatus = async (task_id, token) => {
  try {
    const response = await axios.get(`${CONFIG.API_URL}/tryon/video/${task_id}`, { headers: { Authorization: `Token ${token}` } });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Request failed.' };
  }
};

// Get Generated Videos (with pagination)
export const getVideos = async (page, token) => {
  try {
    const response = await axios.get(
      `${CONFIG.API_URL}/tryon/video/`,
      {
        params: { page, page_size: CONFIG.RECORDS_PER_PAGE, status: "completed" },
        headers: { Authorization: `Token ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: 'Request failed.' };
  }
};
